import { lazy } from "react";

const routes = [
  {
    path: "/money_movement",
    element: lazy(() => import("../pages/Finance/pendingPayments")),
  },
  {
    path: "/sales-commission-voucher",
    element: lazy(() => import("../pages/Finance/SalesCommissionVoucher")),
  },
  {
    path: "/reconciliation_ledger",
    element: lazy(() => import("../pages/Finance/ReconciliationLedger")),
  },
  {
    path: "/view_dpp_ledger/:dppId",
    element: lazy(() => import("../pages/Finance/ViewDppLedger")),
  },
];

export default routes;
